export default __webpack_public_path__ + "static/media/Clone.fc255e49.webp";